var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    { attrs: { color: "primary", padless: "" } },
    [
      _c(
        "v-row",
        { attrs: { justify: "center", "no-gutters": "" } },
        [
          _c(
            "v-col",
            { staticClass: "primary py-4 text-center", attrs: { cols: "12" } },
            [
              _c(
                "span",
                {
                  attrs: {
                    title: _vm.version.concat(" - ").concat(_vm.buildtime)
                  }
                },
                [_vm._v("©")]
              ),
              _vm._v(" " + _vm._s(new Date().getFullYear()) + " — "),
              _c("strong", [_vm._v("Alerce")])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }